import cookieConsent from './components/CookieConsent/CookieConsent.duck';

export default { cookieConsent };
